/* eslint-disable node/no-unsupported-features/es-syntax */
import { REPAIR_ROUTE_NAMES } from "@/shared";
export const REPAIR_ROUTES = [
    {
        name: REPAIR_ROUTE_NAMES.ORDER.LIST,
        path: "/repair",
        meta: {
            title: "words.requests",
        },
        props: (route) => ({
            ...route.params,
            ...route.query,
        }),
        component: () => import("../ui/RepairList.vue"),
    },
    {
        name: REPAIR_ROUTE_NAMES.ORDER.BOARD,
        path: "/repair/board",
        meta: {
            title: "words.requests",
        },
        component: () => import("../ui/RepairBoard.vue"),
    },
    {
        name: REPAIR_ROUTE_NAMES.ORDER.ADD,
        path: "/repair/add",
        meta: {
            title: "words.add_request",
        },
        // Приёмка идёт модалкой поверх списка: маршрут остался прежним,
        // чтобы работали все входы — шапка, доска, уведомление о звонке
        component: () => import("../ui/RepairList.vue"),
    },
    {
        name: REPAIR_ROUTE_NAMES.ORDER.EDIT,
        path: "/repair/edit/:id",
        meta: {
            title: "words.edit_request",
        },
        props: true,
        component: () => import("../ui/RepairEdit.vue"),
    },
    {
        name: REPAIR_ROUTE_NAMES.SERVICE.LIST,
        path: "/repair/service",
        meta: {
            title: "menu.services",
        },
        component: () => import("../ui/ServicePage.vue"),
    },
    {
        name: REPAIR_ROUTE_NAMES.SERVICE.ADD,
        path: "/repair/service/add",
        meta: {
            title: "add_service",
        },
        component: () => import("../ui/ServiceEdit.vue"),
    },
    {
        name: REPAIR_ROUTE_NAMES.SERVICE.EDIT,
        path: "/repair/service/:id",
        meta: {
            title: "words.edit_service",
        },
        props: true,
        component: () => import("../ui/ServiceEdit.vue"),
    },
];
